import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Fabricante } from '../models/fabricante';
import { AppConfigService } from './config/app.config.service';
import { MessageService } from './message.service';

@Injectable({ providedIn: 'root' })
export class FabricanteService {
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        private confServ: AppConfigService) { }

    getFabricantes(): Observable<Fabricante[]> {
        return this.http.get<Fabricante[]>(`${this.confServ.getConfig().apiUrl}/formulas/fabricantes`)
            .pipe(
                tap(_ => this.log('fetched fabricantes')),
                catchError(this.handleError<Fabricante[]>('getFabricantes', []))
            );
    }

    getFabricante(id: number): Observable<Fabricante> {
        const url = `${this.confServ.getConfig().apiUrl}/formulas/fabricantes/${id}`;
        return this.http.get<Fabricante>(url).pipe(
            tap(_ => this.log(`fetched fabricante id=${id}`)),
            catchError(this.handleError<Fabricante>(`getFabricante id=${id}`))
        );
    }

    /* GET fabricantes whose name contains search term */
    searchFabricantes(term: string): Observable<Fabricante[]> {
        if (!term.trim()) {
            // if not search term, return empty fabricante array.
            return of([]);
        }
        return this.http.get<Fabricante[]>(`${this.confServ.getConfig().apiUrlMtto}/formulas/fabricantes/name=${term}`).pipe(
            tap(x => x.length ?
                this.log(`found fabricantes matching "${term}"`) :
                this.log(`no fabricantes matching "${term}"`)),
            catchError(this.handleError<Fabricante[]>('searchFabricantes', []))
        );
    }


    addFabricante(fabricante: Fabricante): Observable<Fabricante> {
        return this.http.post<Fabricante>(`${this.confServ.getConfig().apiUrlMtto}/formulas/fabricantes`, fabricante, this.httpOptions).pipe(
            catchError(this.handleError<Fabricante>('addFabricante'))
        );
    }

    deleteFabricante(id: number): Observable<Fabricante> {
        const url = `${this.confServ.getConfig().apiUrlMtto}/formulas/fabricantes/${id}`;

        return this.http.delete<Fabricante>(url, this.httpOptions).pipe(
            tap(_ => this.log(`deleted fabricante id=${id}`)),
            catchError(this.handleError<Fabricante>('deleteFabricante'))
        );
    }

    updateFabricante(fabricante: Fabricante): Observable<any> {
        return this.http.put(`${this.confServ.getConfig().apiUrlMtto}/formulas/fabricantes`, fabricante, this.httpOptions).pipe(
            tap(_ => this.log(`updated fabricante id=${fabricante.id}`)),
            catchError(this.handleError<any>('updateFabricante'))
        );
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a FabricanteService message with the MessageService */
    private log(message: string) {
        this.messageService.add(`FabricanteService: ${message}`);
    }
}
